module.exports = __webpack_public_path__ + "static/media/phoebe-prof.8b982da5.svg";